/* eslint-disable @typescript-eslint/no-explicit-any */
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";

// pages
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Register from "./pages/Register/Register";
import MyCover from "./pages/WhatsMyCover/WhatsMyCover.tsx";
import Profile from "./pages/Profile/Profile.tsx";
import AdditionalServices from "./pages/AccidentSupport/AdditionalServices";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword.tsx";
import ResetPassword from "./pages/ResetPassword/ResetPassword.tsx";
import AccidentSupport from "./pages/AccidentSupport/AccidentSupport.tsx";
import AccidentSupportList from "./pages/AccidentSupport/AccidentSupportList.tsx";
import Uploads from "./pages/AccidentSupport/Uploads.tsx";
import AddEditVehicle from "./pages/Vehicle/AddEditVehicle.tsx";
import VehicleUploads from "./pages/Vehicle/VehicleUploads.tsx";
import VehicleList from "./pages/Vehicle/VehicleList.tsx";
import GenericFormPage from "./pages/DynamicForms/GenericFormPage";
import DynamicListForm from "./pages/DynamicForms/GenericListForm";
import DynamicFormView from "./pages/DynamicForms/GenericViewForm";
import SingleUploadForm from "./pages/DynamicForms/components/camera/SingleUploads.tsx";
import AccidentSupportDraw from "./pages/AccidentSupport/AccidentSupportDraw.tsx";
import ViewAccidentSupportDetail from "./pages/AccidentSupport/AccidentSupportView";
import AccidentSupportFinal from "./pages/AccidentSupport/AccidentSupportFinal.tsx";
import AddressList from "./pages/Address/AddressList.tsx";
import AddEditAddress from "./pages/Address/AddEditAddress.tsx";
import Scanner from "./pages/DynamicForms/components/vehicle/Scanner.tsx"

// Only shown when there's NO tenant segment
function NoTenant() {
  return (
    <div style={{ padding: 24 }}>
      <h2>No tenant in URL</h2>
      <p>
        Use a tenant path, e.g. <code>/pwa_local/digicall/login</code>.
      </p>
    </div>
  );
}

const routes = (
  <div className="container">
    <Routes>
      {/* All tenant routes */}
      <Route path=":tenant/*" element={<Outlet />}>
        {/* Public */}
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route
          path="forgotpassword"
          element={<ForgotPassword loading={false} />}
        />
        <Route
          path="reset-password"
          element={<ResetPassword loading={false} />}
        />

        {/* Protected (PrivateRoute decides: authed -> show Outlet, else -> /:tenant/login) */}
        <Route element={<PrivateRoute />}>
          {/* /:tenant  → dashboard when authed */}
          <Route index element={<Dashboard loading={false} />} />
          <Route path="dashboard" element={<Dashboard loading={false} />} />

          <Route path="profile" element={<Profile loading={false} />} />
          <Route path="mycover" element={<MyCover loading={false} />} />
          <Route
            path="additionalservices"
            element={<AdditionalServices loading={false} />}
          />

          <Route
            path="accidentsupport"
            element={<AccidentSupport loading={false} />}
          />
          <Route
            path="accidentsupportlist"
            element={<AccidentSupportList loading={false} />}
          />
          <Route
            path="uploads"
            element={<Uploads loading={false} offline={false} />}
          />
          <Route
            path="vehicleaddedit"
            element={<AddEditVehicle loading={false} isEmptyState />}
          />
          <Route
            path="vehicleuploads"
            element={<VehicleUploads loading={false} offline={false} />}
          />
          <Route path="vehiclelist" element={<VehicleList loading={false} />} />

          <Route path="dynamicform" element={<GenericFormPage />} />
          <Route path="dynamiclist" element={<DynamicListForm loading={false} />} />
          <Route
            path="dynamicfromview"
            element={<DynamicFormView loading={false} />}
          />
          <Route
            path="singleupload"
            element={<SingleUploadForm loading={false} offline={false} />}
          />
          <Route
            path="scanner"
            element={<Scanner loading={false} offline={false} />}
          />

          <Route
            path="accidentsupportdraw"
            element={<AccidentSupportDraw loading={false} />}
          />
          <Route
            path="accidentsupportfinal"
            element={<AccidentSupportFinal loading={false} />}
          />
          <Route
            path="viewaccidentsupport"
            element={<ViewAccidentSupportDetail loading={false} />}
          />

          <Route path="addresslist" element={<AddressList loading={false} />} />
          <Route
            path="addeditaddress"
            element={<AddEditAddress loading={false} isEmptyState />}
          />
          <Route
            path="address"
            element={<AddEditAddress loading={false} isEmptyState />}
          />
        </Route>

        {/* Tenant catch-all → that tenant’s login */}
        <Route path="*" element={<Navigate to="login" replace />} />
      </Route>

      {/* No tenant segment at all */}
      <Route index element={<NoTenant />} />
      <Route path="*" element={<NoTenant />} />
    </Routes>
  </div>
);

export default routes;
